import React from "react";
import { Typography as MuiTypography } from "@material-ui/core";
import { CUSTOM_VARIANTS } from "theme/typography";

/**
 * Custom Typography
 *
 * Tailored to solve custom variants from MuiTypography absent in current v4 https://material-ui.com/es/api/typography/.
 * Note: this could be expanded with color variants or other props as we need it.
 * Should be replaced by the original component when MUI v4 is on this project.
 *
 * @returns MuiTypography
 */
const Typography = ({ children, ...props }) => {
  if (CUSTOM_VARIANTS[props.variant]) {
    const { variant, style } = CUSTOM_VARIANTS[props.variant];

    return (
      <MuiTypography {...props} variant={variant} style={style}>
        {children}
      </MuiTypography>
    );
  }
  return <MuiTypography {...props}>{children}</MuiTypography>;
};

export default Typography;
